(() => {
    const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

    function escapeHtml(s) {
        return String(s ?? "")
            .replaceAll("&", "&amp;")
            .replaceAll("<", "&lt;")
            .replaceAll(">", "&gt;")
            .replaceAll('"', "&quot;")
            .replaceAll("'", "&#039;");
    }

    function safeJsonParse(str) {
        try { return JSON.parse(str); } catch (_) { return null; }
    }

    function buildListItem(point, index) {
        const label = LETTERS[index] || String(index + 1);

        const item = document.createElement("button");
        item.type = "button";
        item.className = "locator-item";
        item.setAttribute("data-idx", String(index));
        item.setAttribute("aria-pressed", "false");

        const s1 = escapeHtml(point.subtitle_1 ?? point.subtitle1 ?? point.subtitle ?? "");
        const s2 = escapeHtml(point.subtitle_2 ?? point.subtitle2 ?? "");

        item.innerHTML = `
          <span class="locator-badge" aria-hidden="true">${label}</span>
          <span class="locator-text">
            <span class="locator-title">${escapeHtml(point.title)}</span>
            ${s1 ? `<span class="locator-subtitle locator-subtitle-1">${s1}</span>` : ""}
            ${s2 ? `<span class="locator-subtitle locator-subtitle-2">${s2}</span>` : ""}
          </span>
        `;


        return item;
    }

    function scrollItemIntoView(container, item) {
        if (!container || !item) return;

        // If list is scrollable, this keeps the active item visible.
        try {
            const cRect = container.getBoundingClientRect();
            const iRect = item.getBoundingClientRect();

            const topOverflow = iRect.top < cRect.top;
            const bottomOverflow = iRect.bottom > cRect.bottom;

            if (topOverflow || bottomOverflow) {
                item.scrollIntoView({ block: "nearest", behavior: "smooth" });
            }
        } catch (_) {}
    }

    function initOne(root) {
        if (!root || root.__storeLocatorInited) return;
        if (!(window.google && window.google.maps)) return;

        const mapEl = root.querySelector("[data-store-locator-map]");
        const listEl = root.querySelector("[data-store-locator-list]");
        if (!mapEl || !listEl) return;

        const raw = root.getAttribute("data-points") || "[]";
        const points = safeJsonParse(raw) || [];
        if (!Array.isArray(points) || points.length === 0) return;

        root.__storeLocatorInited = true;

        const bounds = new google.maps.LatLngBounds();
        const map = new google.maps.Map(mapEl, {
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
        });

        const info = new google.maps.InfoWindow();
        const markers = [];
        const items = [];

        // Keep original marker label styles, so we can "highlight" active one and revert.
        const originalMarkerLabels = [];

        let activeIndex = -1;

        function openInfo(index) {
            const p = points[index];
            const m = markers[index];
            if (!p || !m) return;

            const s1 = p.subtitle_1 ?? "";
            const s2 = p.subtitle_2 ?? "";
            const wh1 = p.working_hours1 ?? "";
            const wh2 = p.working_hours2 ?? "";

            const title = p.title ? `<div class="iw-title">${escapeHtml(p.title)}</div>` : "";
            const sub1  = s1 ? `<div class="iw-subtitle iw-subtitle-1">${escapeHtml(s1)}</div>` : "";
            const sub2  = s2 ? `<div class="iw-subtitle iw-subtitle-2">${escapeHtml(s2)}</div>` : "";
            const working_hours1  = s2 ? `<div class="iw-wh iw-wh">${escapeHtml(wh1)}</div>` : "";
            const working_hours2  = s2 ? `<div class="iw-wh iw-wh">${escapeHtml(wh2)}</div>` : "";

            info.setContent(`<div class="iw">${title}${sub1}${sub2}<br>${working_hours1}${working_hours2}</div>`);
            info.open({ map, anchor: m });
        }

        function setActive(index, fromMarker = false) {
            if (index < 0 || index >= items.length) return;

            activeIndex = index;

            items.forEach((el, i) => {
                const isActive = i === index;
                el.classList.toggle("is-active", isActive);
                el.setAttribute("aria-pressed", isActive ? "true" : "false");
            });

            openInfo(index);

            const m = markers[index];
            if (m) {
                if (!fromMarker) map.panTo(m.getPosition());
                // Optional: if you want zoom-in on selection when multiple points
                // map.setZoom(Math.max(map.getZoom(), 14));
            }

            scrollItemIntoView(listEl, items[index]);
        }

        points.forEach((p, i) => {
            const lat = Number(p.lat);
            const lng = Number(p.lng);
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

            const labelText = LETTERS[i] || String(i + 1);
            const pos = { lat, lng };

            bounds.extend(pos);

            const marker = new google.maps.Marker({
                map,
                position: pos,
                label: labelText,
                icon: {
                    anchor: new google.maps.Point(20, 46),
                },
            });

            marker.addListener("click", () => setActive(i, true));

            markers.push(marker);
            originalMarkerLabels.push({ text: labelText });

            const item = buildListItem(p, i);
            listEl.appendChild(item);
            items.push(item);
        });

        if (!markers.length) return;

        if (!markers.length) return;

        const desiredZoom = Number(root.getAttribute("data-zoom"));
        const hasDesiredZoom = Number.isFinite(desiredZoom) && desiredZoom > 0;

        // Initial view
        if (hasDesiredZoom) {
            map.setCenter(bounds.getCenter());
            map.setZoom(desiredZoom);
        } else {
            const singleMode = markers.length === 1;
            if (!singleMode) {
                map.fitBounds(bounds);
            } else {
                map.setCenter(markers[0].getPosition());
                map.setZoom(14);
            }
        }

        listEl.addEventListener("click", (e) => {
            const btn = e.target.closest("[data-idx]");
            if (!btn) return;
            const idx = Number(btn.getAttribute("data-idx"));
            if (!Number.isFinite(idx)) return;
            setActive(idx, false);
        });

        // Keep view on resize
        // - Multiple points: re-fit bounds
        // - Single point: keep same center/zoom
        let lastCenter = map.getCenter();
        let lastZoom = map.getZoom();

        map.addListener("idle", () => {
            lastCenter = map.getCenter();
            lastZoom = map.getZoom();
        });

        window.addEventListener("resize", () => {
            try {
                if (hasDesiredZoom) {
                    map.setCenter(bounds.getCenter());
                    map.setZoom(desiredZoom);
                    return;
                }

                if (markers.length > 1) {
                    map.fitBounds(bounds);
                } else if (lastCenter) {
                    map.setCenter(lastCenter);
                    if (typeof lastZoom === "number") map.setZoom(lastZoom);
                }
            } catch (_) {}
        });

        // Default active
        setActive(0, true);
    }

    function initAll() {
        document.querySelectorAll("[data-store-locator]").forEach(initOne);
    }

    function tryInitNow() {
        if (window.google && window.google.maps) initAll();
    }

    document.addEventListener("store-locator:maps-ready", () => initAll());

    if (document.readyState === "loading") {
        document.addEventListener(
            "DOMContentLoaded",
            () => {
                tryInitNow();

                // UX Builder often injects content dynamically
                const mo = new MutationObserver(() => tryInitNow());
                mo.observe(document.documentElement, { childList: true, subtree: true });
            },
            { once: true }
        );
    } else {
        tryInitNow();
    }
})();
